// Player state: current levels for everything, keyed by stable data IDs.
// Persisted to localStorage always, and to the API when signed in.

export interface PlayerState {
  $version: 1;
  workshop: Record<string, number>;
  enhancements: Record<string, number>;
  uws: Record<string, { unlocked: boolean; subStats: Record<string, number>; plusLevel: number }>;
  cards: Record<string, number>;
  labs: Record<string, number>;
  relics: Record<string, boolean>;
  modules: Record<string, { rarity: string; level: number }>;
}

export const emptyState = (): PlayerState => ({
  $version: 1,
  workshop: {},
  enhancements: {},
  uws: {},
  cards: {},
  labs: {},
  relics: {},
  modules: {},
});

const LOCAL_KEY = "tower.playerState";

export function loadLocal(): PlayerState {
  try {
    const raw = localStorage.getItem(LOCAL_KEY);
    if (!raw) return emptyState();
    const parsed = JSON.parse(raw) as PlayerState;
    if (parsed.$version !== 1) return emptyState();
    return { ...emptyState(), ...parsed };
  } catch {
    return emptyState();
  }
}

export function saveLocal(state: PlayerState): void {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(state));
}
